export default "__VITE_ASSET__BSYAEPnm__"